import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { Route as WalletRoute } from "./_private/wallet";
import { Route as SignInRoute } from "./_public/sign-in.tsx";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    const isAuthenticated = context.getAuthStatus();
    if (isAuthenticated) {
      throw redirect({
        to: WalletRoute.fullPath,
      });
    } else {
      throw redirect({
        to: SignInRoute.fullPath,
      });
    }
  },
  component: () => (
    <>
      <Outlet />
    </>
  ),
});
